var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[_c('Confirmation',{attrs:{"mode":"admin"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }